export const PwpVoiceWebhookInboundSession = {
  webhookName: 'webhookName',
  orgId: 'orgId',
  sessionId: 'sessionId',
};
